// supabaseClient.ts
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL as string;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY as string;

// Singleton-Instanz für Supabase
const supabase = createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
        persistSession: true, // Session im localStorage speichern
        autoRefreshToken: true, // Token automatisch auffrischen
        detectSessionInUrl: true // Session aus URL erkennen (für OAuth)
    }
});

export default supabase;
